import * as rp from 'request-promise';
import moment from 'moment';
import { firebase } from 'util/auth'
import { snapshotToObjects } from 'util/firestore';
import {apiRequest} from 'util/api/util'
import {loadZoom, canceledReservationForClassId, addedReservationForClassId, loadServices, loadInstructors} from 'store/actions/schedulingActions'
import {
    ADD_INSTRUCTOR_RESERVATION,
    ADD_INSTRUCTOR_CLASSES,
    ADD_INSTRUCTOR_RESERVATIONS
} from 'store/reducers/instructorReducer'

export const sendMessageToStudents = (messageModel) => {
    return async (dispatch, getState, { getFirebase, getFirestore }) => {
        var token = await getFirebase().auth().currentUser.getIdToken();
        const options = {
            method: 'POST',
            body: {
                class_id: messageModel.class_id,
                message_html: messageModel.message,
                message: messageModel.message,
                send_direct_messages: messageModel.viaDirectMessage,
                send_emails: messageModel.viaEmail
            },
            uri: `https://us-central1-sutra-prod.cloudfunctions.net/messagingService/sendMessage`,
            json: true,
            auth: {
                bearer: token
            }
        }

        rp(options)
            .then( response => {

            })
            .catch( err => {
                console.log("Error sending message")
            })
        // const firestore = getFirestore();
    }
};

export const fetchInstructorData = (authId, userId) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        // make async call to DB
        // console.log("GETTING STUDIOS")
        const firestore = getFirestore();
        firestore.collection("users").where("authID", "==", authId).get()
            .then(snapshot => { 
                var users = [];
                snapshot.forEach(function(doc) {
                    var data = doc.data();
                    data.platformID = doc.id;
                    users.push(data);
                });
                // console.log(studios.length)
                if (users.length > 0) {
                    console.log(users[0])
                    dispatch({ type: 'SET_INSTRUCTOR', instructor: users[0]})   
                }
                
            })
            .catch( err => {
                console.log("Errror: " + err)
                dispatch({ type: 'GET_INSTRUCTOR_ERROR', err});
            })
        
        
    }
};

export const fetchClassData = (instructorId) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {

        const firestore = getFirestore();
        firestore.collection("classes")
        .where("deleted", "==", false)
        .where("instructor_id", "==", instructorId).get() //.where("start_time", ">=", moment().subtract(7, "days").unix())
            .then(snapshot => {

                const classes = snapshotToObjects(snapshot)
                dispatch({ type: ADD_INSTRUCTOR_CLASSES, classes: classes })
            })
            .catch( err => {
                console.log("Error getting classes: " + err);
            });

        firestore.collection("classes")
        .where("deleted", "==", false)
        .where("host_ids", "array-contains", instructorId).get() //.where("start_time", ">=", moment().subtract(7, "days").unix())
            .then(snapshot => {

                const classes = snapshotToObjects(snapshot)
                dispatch({ type: ADD_INSTRUCTOR_CLASSES, classes: classes })
            })
            .catch( err => {
                console.log("Error getting classes: " + err);
            });
    };
}

export const fetchReservationData = (classId) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {

        return apiRequest(`app/reservationsForClass?classId=${classId}`)
            .then(reservations => {
                console.log("got reservations")
                console.log(reservations)
                // setIsLoading(false)
                if (reservations && reservations.length > 0) {
                    // setReservations(reservations)    
                    dispatch({type: ADD_INSTRUCTOR_RESERVATIONS, reservations: reservations })
                }  
            })
            .catch(err => {
                // setIsLoading(false)
                console.log("error fetching")
            })
    };
}

export const cancelReservation = (reservationId, issueRefund) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        return apiRequest(`app/cancelReservation?reservationId=${reservationId}`, 'POST', {
            issueRefund: issueRefund
        }).then(reservation => {

            const state = getState()
            console.log("STATE: ", state)
            const reservations = getState().instructor.reservations


                // var copyOfReservations = [...reservations]
            const index = reservations.findIndex(val => val.id === reservationId)

            console.log("FOUND THIS RESERVATION: ", reservations[index])

            if (index !== -1) {
                const copiedReservation = {
                    ...reservations[index]
                }

                const updatedReservation = {
                    ...copiedReservation,
                    canceled: true
                }

                dispatch({ type: ADD_INSTRUCTOR_RESERVATIONS, reservations: [updatedReservation] })
                dispatch(canceledReservationForClassId(updatedReservation.classId))

            }
        }).catch(err => {
            // setIsLoading(false)
            window.alert(err)
        })
    }
}

export const checkinReservation = (reservationId, checkedIn) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {


        return apiRequest(`app/checkinReservation?reservationId=${reservationId}&checkedIn=${checkedIn ? 'true' : 'false'}`, 'POST')
            .then(reservation => {

                const {checkedIn, id} = reservation

                const reservations = getState().instructor.reservations

                // var copyOfReservations = [...reservations]
                const index = reservations.findIndex(val => val.id === id)

                if (index !== -1) {
                    const copiedReservation = {
                        ...reservations[index]
                    }
    
                    const updatedReservation = {
                        ...copiedReservation,
                        checkedIn: checkedIn
                    }

                    dispatch({ type: ADD_INSTRUCTOR_RESERVATIONS, reservations: [updatedReservation] })
                }
            })
            .catch(err => {
                window.alert("something went wrong checking in")

            })
    }
}

export const addStudentToClass = (data) => {

    const {classId} = data

    return (dispatch, getState, { getFirebase, getFirestore }) => {

        return apiRequest("app/dashboard/postCheckout", "POST", {
            ...data
        })
        .then(reservation => {
            console.log("Added new student: ", reservation)

            dispatch(addedReservationForClassId(classId))
            dispatch({ type: ADD_INSTRUCTOR_RESERVATIONS, reservations: [reservation] })
        })
        .catch(message => {
            console.log("Error with options: ", message)
            window.alert(message)
        })
    }

}


export const fetchReviewData = (instructorId) => {
    
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        // make async call to DB
        // console.log("GETTING STUDIOS")
        const firestore = getFirestore();
        firestore.collection("reviews").where("instructorUserID", "==", instructorId).get()
            .then(snapshot => {
                if (snapshot.empty) {
                    return;
                }

                var reviews = [];
                snapshot.forEach(function(doc) {
                    var data = doc.data();
                    data.platformID = doc.id;
                    reviews.push(data);
                });
                // console.log(studios.length)
                // console.log("got reviews")
                // console.log(reviews)
                dispatch({ type: 'SET_INSTRUCTOR_REVIEWS', reviews: reviews })   
            })
            .catch( err => {
                console.log("Error getting reviews: " + err);
            });
    }
};

export const fetchDashboardRevenue = (partnerId) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        const thirtyDaysAgo = moment().add(-30, 'days').unix()
        apiRequest(`connect/updatePayments?partnerId=${partnerId}`)
            .then(payments => {
                console.log("UPDATED PAYMENTS")
                return apiRequest(`connect/payments?partnerId=${partnerId}&sinceTimestamp=${thirtyDaysAgo}`)
            })
            .then(payments => {
                // setIsLoading(false)
                if (!payments) {
                    console.log("DIDNT GET ANY PAYMENTS")
                    dispatch({type: "SET_INSTRUCTOR_DASHBOARD_REVENUE", revenue: 0})
                    return
                }
                const totalRevenue = payments.reduce((total, val) => {
                    var toAdd = 0
                    var toSubtract = 0
                    // if (val.amount_received && val.application_fee_amount) {
                    //     toAdd = val.amount_received - val.application_fee_amount
                    // } else 
                    // if (val.amount_received) {
                    //     toAdd = val.amount_received
                    // }
                    if (val?.charges?.data) {
                        val.charges.data.forEach(charge => {
                            toAdd += charge.amount_captured
                            toSubtract += charge.amount_refunded
                        })
                    }

                    return total = total + toAdd - toSubtract
                }, 0)

                console.log("payments: ", payments.length)
                console.log("GOT PAYMENTS: ", totalRevenue)
                dispatch({type: "SET_INSTRUCTOR_DASHBOARD_REVENUE", revenue: totalRevenue})
                
                // console.log(payments)
                // console.log(payments.slice(11,15))
            })
            .catch(err => {
                console.log('Error getting revenue...', )
            })

        // const firestore = getFirestore();
        
        // let paymentsRef = firestore.collection(STRIPE_PAYMENTS_TABLE).doc(partnerId).collection(STRIPE_PAYMENTS_TABLE)

        // paymentsRef.where("created", ">", thirtyDaysAgo).get()
        //     .then(snapshot => {
        //         const payments = snapshotToObjects(snapshot)

        //         const totalRevenue = payments.reduceRight((total, val) => {
        //             var toAdd = 0
        //             if (val.amount_received && val.application_fee_amount) {
        //                 toAdd = val.amount_received - val.application_fee_amount
        //             } else if (val.amount_received) {
        //                 toAdd = val.amount_received
        //             }
        //             return total = total + toAdd
        //         }, 0)

        //         dispatch({type: "SET_INSTRUCTOR_DASHBOARD_REVENUE", revenue: totalRevenue})
        //     })
    }
}

export const fetchDashboardData = (instructorId) => {
    
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        
        // console.log("dispatch dashboard: " + instructorId)
        dispatch(fetchDashboardRevenue(instructorId))
        dispatch(loadZoom());
        dispatch(loadServices());
        dispatch(loadInstructors());
        var syncInstructorDashboardCall = getFirebase().functions().httpsCallable('syncInstructorDashboardCall');
        syncInstructorDashboardCall({instructorId: instructorId})
            .then(response => {
                // console.log("Sync instructor dashboard response :", response)
                const firestore = getFirestore();
                
                return firestore.collection("instructor_dashboards").doc(instructorId).get()
                // return firestore.collection("other_instructor_dashboards").doc(instructorId).get()
            })
            .then(doc => {
                if (!doc.exists) {
                    console.log('Cant find access rights');
                } else {
                    const data = doc.data()
                    dispatch({ type: "SET_INSTRUCTOR_DASHBOARD", dashboard: data});
                }   
            })
            .catch( err => {
                console.log(err)
                console.log("Error getting dashboard data: " + err)
            });
    }
};

export const addReservation = (reservation) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {


        dispatch({type: ADD_INSTRUCTOR_RESERVATION, reservation: reservation})
    }
}